<template>
    <div class="bk-home-main">
        <bkSearchTab :visible="visible" @advHideSearch="advHideSearch"></bkSearchTab>
        <div :class="visible ? 'bk-bg cur' : 'bk-bg'">
            <!-- <video :class="index===0?'cur':''" src="./bg/1.mp4" muted @ended="videoEnd(0)"></video>
            <video :class="index===1?'cur':''" src="./bg/2.mp4" muted @ended="videoEnd(1)"></video>
            <video :class="index===2?'cur':''" src="./bg/3.mp4" muted @ended="videoEnd(2)"></video> -->
            <video :class="index===0?'cur':''" class="" id="bgVideo0" muted autoplay >
                <source src="//img.library.sh.cn/hisdata/bk/bg3/movie.m3u8" type="application/x-mpegURL" >
            </video>
            <video :class="index===1?'cur':''" id="bgVideo1" muted >
                <source src="//img.library.sh.cn/hisdata/bk/bg2/movie.m3u8" type="application/x-mpegURL" >
            </video>
            <video :class="index===2?'cur':''" id="bgVideo2" muted >
                <source src="//img.library.sh.cn/hisdata/bk/bg1/movie.m3u8" type="application/x-mpegURL" >
            </video>
        </div>
        <bkNav :isHideNavSearch="true"></bkNav>
        <div class="bk-search" v-if="!visible">
            <div class="filters">
                <div class="source">
                    <!-- 所有资源 -->
                    <span :class="sourceAll?'all-s cur':'all-s'" @click="changeSource(-1)">所有资源</span>
                    <span :class="sourceFilters[0]===1?'cur':''" @click="changeSource(0)">报</span>
                    <span :class="sourceFilters[1]===1?'cur':''" @click="changeSource(1)">刊</span>
                </div>
                <div class="gate">
                    <!-- 所有类型 -->
                    <span :class="gateAll?'all-s cur':'all-s'" @click="changeCate(-1)">全部类型</span>
                    <span :class="gateFilters[0]===1?'cur':''" @click="changeCate(0)">正文</span>
                    <span :class="gateFilters[1]===1?'cur':''" @click="changeCate(1)">广告</span>
                    <span :class="gateFilters[2]===1?'cur':''" @click="changeCate(2)">图片</span>
                </div>
            </div>
            <div class="ipt-box">
                <div class="ipt">
                    <input type="text" @keyup.enter="simpleSearch" v-model="keyword"/>
                    <a href="javascript:;" @click="simpleSearch" class="sch-btn"></a>
                    <!-- <router-link to="/bk/searchResult" @click.native="simpleSearch" class="sch-btn"></router-link> -->
                </div>
                <a href="javascript:;" class="more-sch" @click="advShowSearch">高级搜索</a>
                <!-- <router-link to="/" class="more-sch">高级搜索</router-link> -->
            </div>
            <div class="links">
                <router-link to="/bk/literature">文献导航</router-link>
                <a href="https://dhc.library.sh.cn/newspapermap/" target="_blank">报馆地图</a>
                <a href="javascript:;"
                    @click="onRelation('http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc', 'bk')"
                >报人关系</a>
                <!-- <a href="javascript:;"
                @click="onRelationHSBR('http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc', 'bk')"
            >红色报人</a> -->
                <router-link :to="{name:'textAnalysis', query:{selectAll: true}}">文本分析</router-link>
                <router-link to="/bk/brandHome">海派品牌</router-link>
            </div>
            <div class="nums">{{bkCommon.bkHomeDescription}}</div>
        </div>
    </div>
</template>

<script>
    import bkNav from './../nav'
    import bkSearchTab from '../bkSearchTab/index'
    export default {
        components:{
            bkNav,
            bkSearchTab
        },
        data(){
            return{
                visible:false,
                keyword: '',
                index: -1,
                sourceFilters:[1,1],
                gateFilters:[1,1,1],
                lastSource  : 0, // 最后一项选中的资源
                lastGate    : 0, // 最后一项选中的类型
                sourceAll   : true,
                gateAll     : true,
                videoPlayer0: null,
                videoPlayer1: null,
                videoPlayer2: null,
                curr: 0, // 循环播放控制
                videoM3U8: [
                    "//img.library.sh.cn/hisdata/bk/bg3/movie.m3u8",
                    "//img.library.sh.cn/hisdata/bk/bg2/movie.m3u8",
                    "//img.library.sh.cn/hisdata/bk/bg1/movie.m3u8",
                ],
            }
        },
        watch:{
            sourceFilters(val){
                this.sourceAll = val.indexOf(0)===-1;
            },
            gateFilters(val){
                this.gateAll = val.indexOf(0)===-1;
            }
        },
        mounted() {
            // document.getElementsByTagName('video')[this.index].play()
            // 初始化videojs插件,背景视频轮播
            this.$nextTick(() => {
                this.videoJsLoopPlay();
                this.esc(this, 1);
            })
        },
        methods:{
            advShowSearch(){ // 显示高级检索
                this.visible = true;
                this.$emit('bkSearchShow', this.visible)
            },
            advHideSearch(){ // 隐藏高级检索
                this.visible = false;
                this.$emit('bkSearchHide', this.visible)
            },
            simpleSearch(){ // 简单检索
                let _searchType  = 1;
                let _sourceTypes = [];
                let _types       = [];
                if(this.sourceFilters[0] == 1) _sourceTypes.push('newspaper');
                if(this.sourceFilters[1] == 1) _sourceTypes.push('magazine');
                if(this.gateFilters[0] == 1) _types.push('Article');
                if(this.gateFilters[1] == 1) _types.push('Advertisement');
                if(this.gateFilters[2] == 1) _types.push('Picture');
                let _simpleParams = {
                    searchType   : _searchType,
                    sourceTypes  : _sourceTypes,
                    types        : _types,
                    simpleKeyword: this.keyword
                }
                this.$router.push({
                    name:"bkSearchResult",
                    params:{
                        searchType: _searchType,
                        simpleParams: JSON.stringify(_simpleParams),
                    }
                });

            },
            videoEnd(a){
                if(a===2){
                    this.index=2
                }else{
                    this.index++
                }
                document.getElementsByTagName('video')[this.index].play()
            },
            changeSource(index){
                if(index===-1&&this.sourceAll){
                    this.sourceFilters.splice(0,2)
                    this.sourceFilters = [1,0]
                    this.$message.warning('请至少勾选一项资源！', 1);
                    return
                }
                if(index===-1&&!this.sourceAll){
                    this.sourceFilters.splice(0,2)
                    this.sourceFilters = [1,1]
                    return
                }
                if(this.sourceFilters[index]===1){
                    this.sourceFilters.splice(index,1,0)
                }else{
                    this.sourceFilters.splice(index,1,1)
                }

                // 请至少勾选一项资源
                for(let i in this.sourceFilters) if(this.sourceFilters[i] == 1) this.lastSource = i;
                if( this.sourceFilters[0] == 0 && this.sourceFilters[1] == 0 ) {
                    this.sourceFilters[this.lastSource] = 1;
                    this.$message.warning('请至少勾选一项资源！', 1);
                }
            },
            changeCate(index){
                if(index===-1&&this.gateAll){
                    this.gateFilters.splice(0,3)
                    this.gateFilters = [1,0,0]
                    this.$message.warning('请至少勾选一项类型！', 1);
                    return
                }
                if(index===-1&&!this.gateAll){
                    this.gateFilters.splice(0,3)
                    this.gateFilters = [1,1,1]
                    return
                }
                if(this.gateFilters[index]===1){
                    this.gateFilters.splice(index,1,0)
                }else{
                    this.gateFilters.splice(index,1,1)
                }

                // 请至少勾选一项类型
                for(let i in this.gateFilters) if(this.gateFilters[i] == 1) this.lastGate = i;
                if( this.gateFilters[0] == 0 && this.gateFilters[1] == 0 && this.gateFilters[2] == 0 ) {
                    this.gateFilters[this.lastGate] = 1;
                    this.$message.warning('请至少勾选一项类型！', 1);
                }
            },
            videoJsLoopPlay(){
                this.videoPlayer0 = this.setVideoJsOptions("bgVideo0");
                this.videoPlayer1 = this.setVideoJsOptions("bgVideo1");
                this.videoPlayer2 = this.setVideoJsOptions("bgVideo2");
                // 视频1开始播放
                this.index = 0;
                // this.videoPlayer0.play();
                // 视频1播放完毕后
                this.videoPlayer0.on("ended", ()=>{
                    this.index = 1;
                    this.videoPlayer1.play();
                })
                // 视频2播放完毕后
                this.videoPlayer1.on("ended", ()=>{
                    this.index = 2;
                    this.videoPlayer2.play();
                })
                // 视频3播放完毕后
                this.videoPlayer2.on("ended", ()=>{
                    this.index = 0;
                    switch (this.curr) {
                        case 0:
                            this.curr  = 1;
                            if(this.curr == 1){
                                // 更换视频地址 type: "application/x-mpegURL"
                                this.videoPlayer0.src({ src: this.videoM3U8[2] })
                                this.videoPlayer1.src({ src: this.videoM3U8[2] })
                                this.curr = -1;
                            }
                            break;
                        default:
                            break;
                    }
                    this.videoPlayer0.play();
                })
            },
            setVideoJsOptions(videoEle){
                const _this  = this;
                // let _video   = document.getElementById(videoEle);
                // 初始化视频方法
                let _videoJs = this.$VideoJs(videoEle, {
                    techOrder: ['html5', 'flash'],
                    language: 'zh-CN',
                    // 确定播放器是否具有用户可以与之交互的控件。没有控件，
                    // 启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: false,
                    // 自动播放属性, muted:静音播放
                    // autoplay: "muted",
                    // 视频封面
                    // poster: this.videoList[this.current].poster,
                    // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                    // preload: "auto",  // "auto"
                    // 设置视频播放器的显示宽度（以像素为单位）
                    width: "100%",
                    // 设置视频播放器的显示高度（以像素为单位）
                    // height: "100%",
                    loop: false, // 是否循环播放
                    bigPlayButton: false,
                    textTrackDisplay: false,
                    posterImage: false, // true
                    errorDisplay: false,
                    playbackRates: [0.25, 0.5, 1, 1.5, 2, 4, 8, 16], //播放倍数
                    hls: {
                        withCredentials: false
                    }
                }, function() {
                    this.on("loadstart",function(){
                        // console.log("开始请求数据 ");
                    })
                    this.on('progress', function () {
                        // console.log('正在请求数据')
                    })
                    this.on("play", function(){
                        // console.log("视频开始播放")
                    })
                    this.on("ended", function () {
                        // console.log('视频'+_this.index+'播放结束了');
                    })
                    this.on("error", function () {
                        console.log("异常，无法播放")
                    })
                })

                return _videoJs;
            }
        },
        beforeDestroy() {
            // 销毁 videoJs 实例
            this.videoPlayer0.dispose();
            this.videoPlayer1.dispose();
            this.videoPlayer2.dispose();
        }
    }
</script>



<style lang="less" scoped>
    .bk-home-main{
        width: 100%;
        min-height: calc(100vh);
        position: relative;
        overflow: hidden;
        .bk-bg{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            pointer-events: none;
            &.cur{
                opacity: 0.6;
            }
            &.gs{
                filter: blur(8px);
            }
            video{
                position: absolute;
                width: 120%;
                height: auto;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                opacity: 0;
                transition: opacity 2s;
                &.cur{
                    opacity: 1;
                }
            }
        }
        .bk-search{
            .ipt-box{
                .ipt{
                    color: #000;
                }
            }
        }
    }
</style>
<style>
    /* 去掉loading图标 */
    .vjs-seeking .vjs-loading-spinner,
    .vjs-waiting .vjs-loading-spinner {
        display: none!important;
    }
</style>